module.exports = __webpack_public_path__ + "static/media/serena2-on.20b17bfe.png";